import { useCallback } from 'react';
import { ANALYTICS_EVENTS } from '@shared/analytics/events';
import type { TerraSignalRow } from '@shared/schemas/terra-signals';
import { gongOpenHref } from '../../../../../../mini-apps/_shared/gong-links';
import { useTrackSignalsEvent } from './signalsAnalytics';

/**
 * The Signals verb button's link: the same-origin `/open` redirect `href`
 * (the server rebuilds the Gong URL; see `gongOpenHref`) plus the one
 * `Action Opened in Gong` emit. The emit is the best-effort client twin of the
 * server's authoritative redirect event; it fires per click and never blocks
 * navigation. Shared by `SignalRowActions` and `SignalResponseRowActions` so
 * the link and its event cannot drift apart.
 */
export type GongOpenLinkRow = Pick<TerraSignalRow, 'signal_id' | 'contact_id' | 'account_id' | 'signal_tactic' | 'step_number'>;

export function useGongOpenLink(row: GongOpenLinkRow): { href: string; onClick: () => void } {
  const trackSignalsEvent = useTrackSignalsEvent();
  const { signal_id: signalId, contact_id: contactId, account_id: accountId, signal_tactic: stepType, step_number: stepNumber } = row;
  const onClick = useCallback(
    () => trackSignalsEvent(ANALYTICS_EVENTS.ACTION_OPENED_IN_GONG, { signalId, contactId, accountId, stepType }),
    [trackSignalsEvent, signalId, contactId, accountId, stepType],
  );
  return { href: gongOpenHref(signalId, contactId, accountId, stepType, stepNumber), onClick };
}
